import { Component, ViewChild } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { DisplayServiceProvider } from '../../../core/services/display-service/display-service';
import { ENVIRONMENT } from '../../../../../environments/environment';
import { FiltersConfig } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filters-config.interface';
import { IClientModel } from '../../../clients/interfaces/i-client-model.interface';
import { IonicPage, ModalController, NavParams } from 'ionic-angular';
import { ListConfig } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/list-config.interface';
import { ModifyProject, ProjectService, SaveProject } from '../../services/project.service';
import { ProjectAddPage } from '../project-add/project-add';
import { ProjectModifyPage } from '../project-modify/project-modify';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { take } from 'rxjs/operators';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';
import {
  FiltersService,
  ListRendererComponent,
} from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { DataViewClient, DataViewAllClientsService } from '../../services/data-view-all_clients.service';

@IonicPage()
@Component({
  selector: 'page-projects',
  templateUrl: 'projects.html',
})
export class ProjectsPage {
  @ViewChild(ListRendererComponent)
  projectList: ListRendererComponent;

  public config: ListConfig;
  public db: any;
  public loading = true;
  public engineUrl = ENVIRONMENT.engineUrl;
  public filtersConfig: FiltersConfig;
  public sortByKey: string = 'start_date';
  public sortByDirection: 'ASC' | 'DESC' = 'DESC';
  private dataReceived = false;
  public baseUrl = ENVIRONMENT.engineUrl;
  public clientFromContext: IClientModel = null;
  private clientData: DataViewClient;
  public filtersLoading = false;

  constructor(
    private displayService: DisplayServiceProvider,
    private filtersService: FiltersService,
    private modalCtrl: ModalController,
    private projectService: ProjectService,
    private storageService: StorageServiceProvider,
    public configService: ConfigServiceProvider,
    public textService: TextServiceProvider,
    private navParams: NavParams,
    private dataViewClientsService: DataViewAllClientsService,
  ) {}

  ngOnInit() {
    this.config = this.displayService.getScreenComponent('projects', 'projects');
    this.filtersConfig = this.displayService.getScreenComponent('projects_filters', 'projects_filters');

    this.db = this.storageService.db;
    this.clientFromContext = this.navParams.get('client');
  }

  ionViewDidEnter() {
    this.loading = true;
    if (this.clientFromContext) {
      this.getClientFromDataView(() => this.refreshProjectList(ENVIRONMENT.defaultDataViewTimeout));
    } else {
      this.refreshProjectList(ENVIRONMENT.defaultDataViewTimeout);
    }
  }

  private getClientFromDataView(callback: Function): void {
    this.dataViewClientsService
      .getClientFromDataViewByClientId(this.clientFromContext.clientId)
      .pipe(take(1))
      .subscribe((client) => {
        this.clientData = client;
        callback();
      });
  }

  private refreshProjectList(timeout: number): void {
    this.filtersLoading = true;
    setTimeout(() => {
      this.applyContextFilter();
      setTimeout(() => (this.filtersLoading = false), timeout);
    }, timeout);
  }

  private applyContextFilter(): void {
    if (this.clientData) {
      this.filtersService.applyFilters('projects', [
        {
          column: 'clients',
          type: 'STRING',
          value: this.clientData.id,
          queryValue: {
            column: 'clients',
            type: 'NESTED',
            value: this.clientData.id,
            nestedType: 'EQUALS',
            nestedColumn: 'id',
          },
        },
      ]);
    } else {
      this.filtersService.applyFilters('projects', []);
    }
  }

  public openAddProjectForm() {
    const modal = this.modalCtrl.create(ProjectAddPage, {
      client: this.clientData,
    });
    modal.onDidDismiss((project: SaveProject) => {
      if (project) {
        this.saveProject(project);
      }
    });
    modal.present();
  }

  private saveProject(project: SaveProject): void {
    this.loading = true;
    this.projectService
      .saveProject({
        ...project,
        clients: project.clients.map((client) => ({
          client: client.client.id,
        })),
      })
      .subscribe(
        () => this.refreshProjectList(ENVIRONMENT.defaultDataViewTimeout),
        (error) => console.error(error),
      );
  }

  public navigateTo($task: { viewId: string; element?: Object; objectKey?: Object }) {
    const modal = this.modalCtrl.create(ProjectModifyPage, {
      project: $task.element,
    });
    modal.onDidDismiss((project: ModifyProject) => {
      if (project) {
        this.modifyProject(project);
      }
    });
    modal.present();
  }

  private modifyProject(project: ModifyProject): void {
    this.loading = true;
    this.projectService
      .editProject({
        ...project,
        clients: project.clients.map((client) => ({
          client: client.client.id,
        })),
      })
      .subscribe(
        () => this.refreshProjectList(ENVIRONMENT.defaultDataViewTimeout),
        (error) => console.error(error),
      );
  }

  public handleDataLoadingEnd(data: any) {
    const projectId = this.navParams.get('pushProjectId');
    let project;
    if (!this.dataReceived && projectId) project = data.find((task) => task.id === projectId);
    if (project) this.navigateTo({ viewId: '', element: project });
    this.extractOptionsFromData(data);
  }

  public extractOptionsFromData(data: any[]) {
    if (!this.dataReceived && !this.clientFromContext && data.length > 0) {
      this.filtersService.extractOptionsFromData('projects', data);
      this.dataReceived = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/projects/pages/project-list/projects.ts